export function IsoIcon({ active }: any) {
  const color: string = active ? "#006AB3" : "#000000";
  return (
    <svg
      width="25"
      height="13"
      viewBox="0 0 25 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4966 4.00475H11.5503C12.1845 4.00475 12.604 4.50175 12.604 5.00849H13.6576C13.6576 3.90729 12.7165 3.01074 11.5605 3.01074H10.5068C9.35081 3.01074 8.40964 3.90729 8.40964 5.00849C8.40964 6.10969 9.35081 7.00624 10.5068 7.00624H11.5605C12.1948 7.00624 12.6142 7.4058 12.6142 8.00999C12.6142 8.61419 12.1948 9.01374 11.5605 9.01374H10.5068C9.87254 9.01374 9.45311 8.51674 9.45311 8.00999H8.39941C8.39941 9.11119 9.34058 10.0077 10.4966 10.0077H11.5503C12.7063 10.0077 13.6474 9.11119 13.6474 8.00999C13.6474 6.90879 12.7063 6.01224 11.5503 6.01224H10.4966C9.86231 6.01224 9.44288 5.61269 9.44288 5.00849C9.44288 4.4043 9.87254 4.00475 10.4966 4.00475Z"
        fill={color}
      />
      <path
        d="M4.19531 4.00473H5.249V9.00398H4.19531V10.0077H7.34616V9.00398H6.3027V4.00473H7.35639V3.00098H4.19531V4.00473Z"
        fill={color}
      />
      <path
        d="M17.8403 3.00098H16.7866C15.6306 3.00098 14.6895 3.89753 14.6895 4.99873V8.00023C14.6895 9.10143 15.6306 9.99798 16.7866 9.99798H17.8403C18.9963 9.99798 19.9375 9.10143 19.9375 8.00023V4.99873C19.9477 3.89753 18.9963 3.00098 17.8403 3.00098ZM18.894 8.00023C18.894 8.60442 18.4746 9.00398 17.8403 9.00398H16.7866C16.1523 9.00398 15.7329 8.60442 15.7329 8.00023V4.99873C15.7329 4.39453 16.1523 3.99498 16.7866 3.99498H17.8403C18.4746 3.99498 18.894 4.39453 18.894 4.99873V8.00023Z"
        fill={color}
      />
      <path
        d="M20.992 0H3.15085C1.36059 0 0 1.2961 0 3.0015V9.9985C0 11.6942 1.36059 13 3.15085 13H20.992C22.772 13 24.1429 11.7039 24.1429 9.9985V3.0015C24.1429 1.2961 22.7823 0 20.992 0ZM23.0994 9.9985C23.0994 11.0997 22.1582 11.9963 21.0022 11.9963H3.15085C1.99485 11.9963 1.05369 11.0997 1.05369 9.9985V3.0015C1.05369 1.9003 1.99485 1.00375 3.15085 1.00375H20.992C22.148 1.00375 23.0892 1.9003 23.0892 3.0015L23.0994 9.9985Z"
        fill={color}
      />
    </svg>
  );
}
